import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Logout from '@mui/icons-material/Logout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Auth } from 'aws-amplify';

import logo from '../assets/Adfectus_logo.png'

export default function Header({ signOut, title }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userInitial, setUserInitial] = useState('');
  const open = Boolean(anchorEl);

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        const name = user.attributes?.name || user.attributes?.given_name || user.username || '';
        setUserInitial(name.charAt(0).toUpperCase());
      })
      .catch(() => setUserInitial(''));
  }, []);

  const handleClickSettings = (event) => {
    //TODO 1) own name 2) Settings
    setAnchorEl(event.currentTarget);
  };

  const handleClickNotification = (event) => {
    //TODO badge when new notification
  };

  const handleClickHelp = (event) => {
    //TODO add help notes
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          borderBottom: '1px solid #E5E7EB',
          bgcolor: '#F8FAFC',
          width: '100%',
          minHeight: 96,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          textAlign: 'left',
          padding: '16px 24px 16px 32px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Box sx={{ width: 120, height: 64, display: 'flex', alignItems: 'center', paddingRight: 8, boxSizing: 'border-box', borderRight: '2px solid #E5E7EB', flexShrink: 0 }}>
            <img style={{ height: 44, width: 'auto' }} src={logo} alt="Logo" />
          </Box>
          {title && (
            <Box sx={{ paddingLeft: 4, textAlign: 'left' }}>
              <Typography sx={{ color: '#102A56', fontSize: 20, lineHeight: 1.1, fontWeight: 700 }}>
                {title}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginTop: 0.75 }}>

                <Typography sx={{ color: '#475569', fontSize: 16, lineHeight: 1.2 }}>
                  Beitostølen Helsesportsenter
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Tooltip title="Kontoinnstillinger">
          <IconButton onClick={handleClickSettings} size="small" sx={{ ml: 2, gap: 1 }}>
            <Avatar sx={{ width: 40, height: 40, bgcolor: '#E2E8F0', color: '#102A56', fontSize: 20 }}>{userInitial}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={signOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logg ut
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
